// PIPE NETWORK PDF RENDERER v5 — all fixes
import autoTable from "jspdf-autotable";

var NAVY = [26, 39, 68], RED = [139, 30, 30], GRAY = [100, 100, 100];
var BLUE = [37, 99, 235], ORANGE = [217, 119, 6], BLACK = [30, 41, 59], WHITE = [255, 255, 255];
var VER = "2.3.0";

function fmtDate() { return new Date().toISOString().replace("T", " ").slice(0, 19); }
function iso(x, y, z) { return { sx: (x - y) * 0.866, sy: (x + y) * 0.5 - z }; }
function nById(n, id) { return n.nodes.find(function(x) { return x.id === id; }); }

function addFooter(doc, pg) {
  var pw = doc.internal.pageSize.getWidth(), ph = doc.internal.pageSize.getHeight();
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text("Software Version " + VER + "    Calculation Performed: " + fmtDate() + " EST", pw / 2, ph - 15, { align: "center" });
  doc.text("Page " + pg, pw - 20, ph - 15, { align: "right" });
  doc.text("Copyright \u00A9 Boal Systems Inc. Fort Lauderdale, FL USA", pw / 2, ph - 10, { align: "center" });
}

function addLogo(doc, logoB64, x, y, w, h) {
  try {
    if (logoB64) {
      doc.setFillColor(255, 255, 255);
      doc.rect(x, y, w, h, "F");
      doc.addImage(logoB64, "JPEG", x, y, w, h);
    }
  } catch (e) { /* logo unavailable */ }
}

function addPageHeader(doc, logoB64, m) {
  addLogo(doc, logoB64, m, 8, 25, 25);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text("FK 5112 BOM Report", m + 28, 18);
}

export function drawPipeNetworkPage(doc, network, title, uL, startY) {
  var pw = doc.internal.pageSize.getWidth(), m = 20;
  var dW = pw - m * 2, dH = doc.internal.pageSize.getHeight() - startY - 50;
  var dCx = m + dW / 2, dCy = startY + dH / 2;

  // Bounds
  var mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
  for (var i = 0; i < network.nodes.length; i++) {
    var p = iso(network.nodes[i].x, network.nodes[i].y, network.nodes[i].z || 0);
    if (p.sx < mnx) mnx = p.sx; if (p.sy < mny) mny = p.sy;
    if (p.sx > mxx) mxx = p.sx; if (p.sy > mxy) mxy = p.sy;
  }
  if (network.nodes.length <= 1) { mnx = -50; mxx = 50; mny = -50; mxy = 50; }
  var nW = Math.max(mxx - mnx, 80), nH = Math.max(mxy - mny, 80);
  var sc = Math.min(dW / (nW + 80), dH / (nH + 100), 0.85);
  var cx = (mnx + mxx) / 2, cy = (mny + mxy) / 2;
  function tx(sx) { return dCx + (sx - cx) * sc; }
  function ty(sy) { return dCy + (sy - cy) * sc; }

  // Drawing border
  doc.setDrawColor(210, 210, 210); doc.setLineWidth(0.15); doc.rect(m, startY, dW, dH);
  doc.setFontSize(9); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
  doc.text(title, m + 4, startY - 2);

  // Axis indicator with UP/DN
  var axX = m + dW - 18, axY = startY + 18, al = 10;
  var aN = iso(0, -al, 0), aE = iso(al, 0, 0), aW = iso(-al, 0, 0), aS = iso(0, al, 0);
  doc.setDrawColor(190, 190, 190); doc.setLineWidth(0.15);
  doc.line(axX, axY, axX + aN.sx, axY + aN.sy); doc.line(axX, axY, axX + aE.sx, axY + aE.sy);
  doc.line(axX, axY, axX + aW.sx, axY + aW.sy); doc.line(axX, axY, axX + aS.sx, axY + aS.sy);
  doc.line(axX, axY, axX, axY - al); doc.line(axX, axY, axX, axY + al);
  doc.setFont("helvetica", "normal"); doc.setFontSize(5); doc.setTextColor.apply(doc, GRAY);
  doc.text("N", axX + aN.sx, axY + aN.sy - 1); doc.text("E", axX + aE.sx + 1, axY + aE.sy + 3);
  doc.text("W", axX + aW.sx - 4, axY + aW.sy - 1); doc.text("S", axX + aS.sx, axY + aS.sy + 4);
  doc.text("UP", axX + 2, axY - al); doc.text("DN", axX + 2, axY + al + 3);

  // Edges
  for (var ei = 0; ei < network.edges.length; ei++) {
    var edge = network.edges[ei];
    var fn = nById(network, edge.from), tn = nById(network, edge.to);
    if (!fn || !tn) continue;
    var fp = iso(fn.x, fn.y, fn.z || 0), tp = iso(tn.x, tn.y, tn.z || 0);
    var x1 = tx(fp.sx), y1 = ty(fp.sy), x2 = tx(tp.sx), y2 = ty(tp.sy);
    var isHose = edge.edgeType === "hose";
    var lw = isHose ? 0.3 : Math.max(0.2, Math.min((parseInt(edge.diameter) || 25) / 40, 0.8));
    doc.setDrawColor.apply(doc, isHose ? BLUE : BLACK); doc.setLineWidth(lw);
    doc.line(x1, y1, x2, y2);

    // Label with perpendicular offset to avoid overlaps
    if (!isHose) {
      var dx = x2 - x1, dy = y2 - y1, len = Math.sqrt(dx * dx + dy * dy) || 1;
      var ox = -dy / len * 4, oy = dx / len * 4;
      var mx = (x1 + x2) / 2 + ox, my = (y1 + y2) / 2 + oy;
      doc.setFont("helvetica", "normal"); doc.setFontSize(4.5); doc.setTextColor.apply(doc, NAVY);
      doc.text(edge.length + uL, mx, my);
      doc.setFontSize(3.5); doc.setTextColor.apply(doc, GRAY);
      var lbl = "\u00F8" + edge.diameter + "mm";
      if (edge.direction === "UP" || edge.direction === "DOWN") lbl += " (" + edge.direction + ")";
      doc.text(lbl, mx, my + 2.5);
    }
  }

  // Nodes — cylinder drawn with valve on top, body below
  for (var ni = 0; ni < network.nodes.length; ni++) {
    var node = network.nodes[ni], np = iso(node.x, node.y, node.z || 0);
    var nx = tx(np.sx), ny = ty(np.sy);

    if (node.type === "cylinder") {
      // Valve at node position (where hose connects)
      doc.setDrawColor.apply(doc, RED); doc.setFillColor(252, 165, 165); doc.setLineWidth(0.2);
      doc.rect(nx - 1.5, ny - 1.5, 3, 3, "FD");
      // Body below valve
      doc.setFillColor(254, 226, 226); doc.setLineWidth(0.2);
      doc.ellipse(nx, ny + 3, 3, 1.2, "FD");
      doc.rect(nx - 3, ny + 3, 6, 9, "FD");
      doc.setFontSize(3.5); doc.setTextColor.apply(doc, RED); doc.text("CYL", nx - 3, ny + 16);
    } else if (node.type === "nozzle") {
      doc.setDrawColor.apply(doc, BLUE); doc.setFillColor(219, 234, 254); doc.setLineWidth(0.2);
      doc.triangle(nx, ny - 2.5, nx - 2.5, ny + 1.5, nx + 2.5, ny + 1.5, "FD");
      doc.setFont("helvetica", "normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, BLUE);
      doc.text(node.label || "", nx - 1, ny + 5);
    } else if (node.type === "tee") {
      doc.setDrawColor.apply(doc, ORANGE); doc.setFillColor(254, 249, 195); doc.setLineWidth(0.2);
      doc.rect(nx - 1.5, ny - 1.5, 3, 3, "FD");
      doc.setFont("helvetica", "normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, GRAY);
      doc.text(node.label || "", nx - 1, ny - 3);
    } else {
      doc.setDrawColor(5, 150, 105); doc.setFillColor(236, 253, 245); doc.setLineWidth(0.15);
      doc.circle(nx, ny, 1, "FD");
      doc.setFont("helvetica", "normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, GRAY);
      doc.text(node.label || "", nx - 1, ny - 2.5);
    }
  }

  // Legend
  var ly = startY + dH - 4;
  doc.setFont("helvetica", "normal"); doc.setFontSize(4.5); doc.setTextColor.apply(doc, GRAY);
  doc.setFillColor(254, 226, 226); doc.setDrawColor.apply(doc, RED); doc.setLineWidth(0.15);
  doc.rect(m + 3, ly - 1.5, 2.5, 2.5, "FD"); doc.text("Cylinder", m + 7, ly + 0.5);
  doc.setFillColor(236, 253, 245); doc.setDrawColor(5, 150, 105);
  doc.circle(m + 32, ly - 0.3, 0.8, "FD"); doc.text("Junction", m + 35, ly + 0.5);
  doc.setFillColor(254, 249, 195); doc.setDrawColor.apply(doc, ORANGE);
  doc.rect(m + 58, ly - 1, 2, 2, "FD"); doc.text("Tee", m + 62, ly + 0.5);
  doc.setFillColor(219, 234, 254); doc.setDrawColor.apply(doc, BLUE);
  doc.triangle(m + 74, ly - 1, m + 72.5, ly + 1, m + 75.5, ly + 1, "FD"); doc.text("Nozzle", m + 78, ly + 0.5);
}

function countFittings(network) {
  var elbows = 0, tees = 0, nozzles = 0;
  network.nodes.forEach(function(n) {
    if (n.type === "nozzle") { nozzles++; return; }
    if (n.type === "cylinder") return;
    var ee = network.edges.filter(function(e) { return (e.from === n.id || e.to === n.id) && e.edgeType !== "hose"; });
    if (ee.length >= 3) { tees++; return; }
    if (ee.length === 2) {
      var d1 = ee[0].direction, d2 = ee[1].direction;
      if (d1 && d2 && d1 !== d2) elbows++;
    }
  });
  return { elbows: elbows, tees: tees, nozzles: nozzles };
}

function getDiameterAtNode(network, nodeId) {
  var ee = network.edges.filter(function(e) { return (e.from === nodeId || e.to === nodeId) && e.edgeType !== "hose"; });
  if (ee.length === 0) return "\u2014";
  var diams = ee.map(function(e) { return e.diameter || "25"; });
  var unique = diams.filter(function(d, i) { return diams.indexOf(d) === i; });
  return unique.map(function(d) { return "\u00F8" + d + "mm"; }).join(" / ");
}

function addPipingBOMPage(doc, network, encName, uL, pg, logoBase64) {
  var pw = doc.internal.pageSize.getWidth(), m = 20;
  doc.addPage(); pg++;
  addPageHeader(doc, logoBase64, m);
  doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
  doc.text("Piping Bill of Materials", pw / 2, 42, { align: "center" });
  doc.setFontSize(10); doc.text(encName, m, 52);

  // Detailed segment table
  var segRows = [], totalLen = 0;
  network.edges.forEach(function(e) {
    var fromL = (nById(network, e.from) || {}).label || "?";
    var toL = (nById(network, e.to) || {}).label || "?";
    if (e.edgeType === "hose") {
      segRows.push([fromL, toL, "W", e.length + " " + uL, "\u2014", "Flex Hose", "Discharge hose"]);
      return;
    }
    segRows.push([fromL, toL, e.direction || "\u2014", e.length + " " + uL, "\u00F8" + (e.diameter || "25") + "mm", e.pipeType || "40T", ""]);
    totalLen += parseFloat(e.length) || 0;
  });

  autoTable(doc, {
    startY: 58, head: [["From", "To", "Dir", "Length", "Diameter", "Type", "Notes"]], body: segRows,
    margin: { left: m, right: m }, headStyles: { fillColor: RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 },
    bodyStyles: { fontSize: 7.5 },
    columnStyles: { 0: { cellWidth: 14, halign: "center" }, 1: { cellWidth: 14, halign: "center" }, 2: { cellWidth: 14, halign: "center" }, 3: { cellWidth: 22 }, 4: { cellWidth: 22 }, 5: { cellWidth: 20 } }
  });

  var y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : 80) + 10;

  // Pipe summary by diameter
  var pipes = {};
  network.edges.forEach(function(e) {
    if (e.edgeType === "hose") return;
    var k = (e.diameter || "25") + "mm " + (e.pipeType || "40T");
    if (!pipes[k]) pipes[k] = { diameter: e.diameter || "25", type: e.pipeType || "40T", length: 0, segments: 0 };
    pipes[k].length += parseFloat(e.length) || 0; pipes[k].segments++;
  });
  var pRows = Object.values(pipes).map(function(p) { return ["\u00F8" + p.diameter + " mm", p.type, p.length.toFixed(2) + " " + uL, String(p.segments)]; });
  if (pRows.length > 0) {
    doc.setFontSize(10); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("Pipe Summary by Diameter", m, y); y += 4;
    autoTable(doc, { startY: y, head: [["Diameter", "Type", "Total Length", "Segments"]], body: pRows, margin: { left: m, right: m }, headStyles: { fillColor: RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 }, bodyStyles: { fontSize: 8 }, columnStyles: { 0: { cellWidth: 30 }, 1: { cellWidth: 25 } } });
    y = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y + 20) + 8;
  }

  // Fittings & Accessories — with Diameter column
  var fit = countFittings(network);
  doc.setFontSize(10); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
  doc.text("Fittings & Accessories", m, y); y += 4;
  var fRows = [];
  if (fit.elbows > 0) {
    // Find elbows and their diameters
    var elbowDiams = [];
    network.nodes.forEach(function(n) {
      if (n.type === "cylinder" || n.type === "nozzle") return;
      var ee = network.edges.filter(function(e) { return (e.from === n.id || e.to === n.id) && e.edgeType !== "hose"; });
      if (ee.length === 2 && ee[0].direction !== ee[1].direction) elbowDiams.push(getDiameterAtNode(network, n.id));
    });
    fRows.push(["Elbow (90\u00B0)", String(fit.elbows), elbowDiams.join(", ") || "\u2014", "At direction changes"]);
  }
  if (fit.tees > 0) {
    var teeDiams = [];
    network.nodes.forEach(function(n) {
      if (n.type === "tee") teeDiams.push(getDiameterAtNode(network, n.id));
    });
    fRows.push(["Tee", String(fit.tees), teeDiams.join(", ") || "\u2014", "At branch points"]);
  }
  if (fit.nozzles > 0) {
    var nozDiams = [];
    network.nodes.forEach(function(n) {
      if (n.type === "nozzle") nozDiams.push(getDiameterAtNode(network, n.id));
    });
    fRows.push(["Nozzle", String(fit.nozzles), nozDiams.join(", ") || "\u2014", "Terminal discharge"]);
  }
  fRows.push(["Flex Discharge Hose", "1", "\u2014", "Metal braided cylinder hose"]);

  autoTable(doc, {
    startY: y, head: [["Item", "Qty", "Diameter", "Notes"]], body: fRows,
    margin: { left: m, right: m },
    headStyles: { fillColor: RED, textColor: WHITE, fontStyle: "bold", fontSize: 8 },
    bodyStyles: { fontSize: 8 },
    columnStyles: { 0: { cellWidth: 45 }, 1: { cellWidth: 12, halign: "center" }, 2: { cellWidth: 35 } }
  });

  var y2 = (doc.lastAutoTable ? doc.lastAutoTable.finalY : y + 20) + 6;
  doc.setFont("helvetica", "normal"); doc.setFontSize(8); doc.setTextColor.apply(doc, GRAY);
  doc.text("Total pipe length (excl. hose): " + totalLen.toFixed(2) + " " + uL, m, y2);

  addFooter(doc, pg);
  return pg;
}


// Orthographic projection functions
function projTopDown(x, y, z) { return { sx: x, sy: -y }; }        // View from above (Up to Down)
function projSideEW(x, y, z) { return { sx: -y, sy: -(z || 0) }; } // View E to W (looking West)
function projSideSN(x, y, z) { return { sx: x, sy: -(z || 0) }; }  // View S to N (looking North)

function drawOrthoView(doc, network, title, uL, startY, projFn) {
  var pw = doc.internal.pageSize.getWidth(), m = 20;
  var dW = pw - m * 2, dH = doc.internal.pageSize.getHeight() - startY - 50;
  var dCx = m + dW / 2, dCy = startY + dH / 2;
  var mnx = Infinity, mny = Infinity, mxx = -Infinity, mxy = -Infinity;
  for (var i = 0; i < network.nodes.length; i++) {
    var p2 = projFn(network.nodes[i].x, network.nodes[i].y, network.nodes[i].z || 0);
    if (p2.sx < mnx) mnx = p2.sx; if (p2.sy < mny) mny = p2.sy;
    if (p2.sx > mxx) mxx = p2.sx; if (p2.sy > mxy) mxy = p2.sy;
  }
  if (network.nodes.length <= 1) { mnx = -50; mxx = 50; mny = -50; mxy = 50; }
  var nW = Math.max(mxx - mnx, 80), nH = Math.max(mxy - mny, 80);
  var sc = Math.min(dW / (nW + 80), dH / (nH + 80), 0.85);
  var cx = (mnx + mxx) / 2, cy = (mny + mxy) / 2;
  function tx(sx) { return dCx + (sx - cx) * sc; }
  function ty(sy) { return dCy + (sy - cy) * sc; }
  doc.setDrawColor(210, 210, 210); doc.setLineWidth(0.15); doc.rect(m, startY, dW, dH);
  doc.setFontSize(9); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
  doc.text(title, m + 4, startY - 2);
  // Edges
  for (var ei = 0; ei < network.edges.length; ei++) {
    var edge = network.edges[ei];
    var fn2 = nById(network, edge.from), tn2 = nById(network, edge.to);
    if (!fn2 || !tn2) continue;
    var fp2 = projFn(fn2.x, fn2.y, fn2.z || 0), tp2 = projFn(tn2.x, tn2.y, tn2.z || 0);
    var x1 = tx(fp2.sx), y1 = ty(fp2.sy), x2 = tx(tp2.sx), y2 = ty(tp2.sy);
    var isHose = edge.edgeType === "hose";
    var lw = isHose ? 0.3 : Math.max(0.2, Math.min((parseInt(edge.diameter) || 25) / 40, 0.8));
    doc.setDrawColor.apply(doc, isHose ? [37,99,235] : [30,41,59]); doc.setLineWidth(lw);
    doc.line(x1, y1, x2, y2);
    if (!isHose) {
      var dx2 = x2 - x1, dy2 = y2 - y1, len2 = Math.sqrt(dx2*dx2+dy2*dy2) || 1;
      var ox2 = -dy2/len2*4, oy2 = dx2/len2*4;
      var mx2 = (x1+x2)/2+ox2, my2 = (y1+y2)/2+oy2;
      doc.setFont("helvetica","normal"); doc.setFontSize(4); doc.setTextColor.apply(doc, NAVY);
      doc.text(edge.length + uL, mx2, my2);
      doc.setFontSize(3); doc.setTextColor.apply(doc, GRAY);
      doc.text("d" + edge.diameter + "mm", mx2, my2 + 2);
    }
  }
  // Nodes
  for (var ni = 0; ni < network.nodes.length; ni++) {
    var node = network.nodes[ni], np2 = projFn(node.x, node.y, node.z || 0);
    var nx2 = tx(np2.sx), ny2 = ty(np2.sy);
    if (node.type === "cylinder") {
      doc.setDrawColor.apply(doc, RED); doc.setFillColor(254,226,226); doc.setLineWidth(0.2);
      doc.circle(nx2, ny2, 3, "FD");
      doc.setFontSize(3.5); doc.setTextColor.apply(doc, RED); doc.text("CYL", nx2-3, ny2+6);
    } else if (node.type === "nozzle") {
      doc.setDrawColor.apply(doc, [37,99,235]); doc.setFillColor(219,234,254); doc.setLineWidth(0.2);
      doc.triangle(nx2, ny2-2.5, nx2-2.5, ny2+1.5, nx2+2.5, ny2+1.5, "FD");
      doc.setFont("helvetica","normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, [37,99,235]);
      doc.text(node.label || "", nx2-1, ny2+5);
    } else if (node.type === "tee") {
      doc.setDrawColor.apply(doc, [217,119,6]); doc.setFillColor(254,249,195); doc.setLineWidth(0.2);
      doc.rect(nx2-1.5, ny2-1.5, 3, 3, "FD");
      doc.setFont("helvetica","normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, GRAY);
      doc.text(node.label || "", nx2-1, ny2-3);
    } else {
      doc.setDrawColor(5,150,105); doc.setFillColor(236,253,245); doc.setLineWidth(0.15);
      doc.circle(nx2, ny2, 1, "FD");
      doc.setFont("helvetica","normal"); doc.setFontSize(3.5); doc.setTextColor.apply(doc, GRAY);
      doc.text(node.label || "", nx2-1, ny2-2.5);
    }
  }
}

export function addPipeNetworkPages(doc, enclosureResults, pipeNetworks, uL, logoBase64, startPage) {
  var pg = startPage, m = 20;
  if (!pipeNetworks || Object.keys(pipeNetworks).length === 0) return pg;

  for (var idx = 0; idx < enclosureResults.length; idx++) {
    var pn = pipeNetworks[idx];
    if (!pn || !pn.network || pn.network.nodes.length <= 1) continue;

    // Drawing page
    doc.addPage(); pg++;
    addPageHeader(doc, logoBase64, m);
    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("Pipe Network Drawing", doc.internal.pageSize.getWidth() / 2, 42, { align: "center" });
    var encName = enclosureResults[idx].name || ("Enclosure " + (idx + 1));
    drawPipeNetworkPage(doc, pn.network, encName + " \u2014 Isometric View", uL, 52);
    addFooter(doc, pg);

    // Top-down view (Plan View)
    doc.addPage(); pg++;
    addPageHeader(doc, logoBase64, m);
    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("Pipe Network Drawing", doc.internal.pageSize.getWidth() / 2, 42, { align: "center" });
    drawOrthoView(doc, pn.network, encName + " -- Plan View (Top Down)", uL, 52, projTopDown);
    addFooter(doc, pg);

    // Side view E to W
    doc.addPage(); pg++;
    addPageHeader(doc, logoBase64, m);
    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("Pipe Network Drawing", doc.internal.pageSize.getWidth() / 2, 42, { align: "center" });
    drawOrthoView(doc, pn.network, encName + " -- Side View (East to West)", uL, 52, projSideEW);
    addFooter(doc, pg);

    // Side view S to N
    doc.addPage(); pg++;
    addPageHeader(doc, logoBase64, m);
    doc.setFontSize(14); doc.setFont("helvetica", "bold"); doc.setTextColor.apply(doc, NAVY);
    doc.text("Pipe Network Drawing", doc.internal.pageSize.getWidth() / 2, 42, { align: "center" });
    drawOrthoView(doc, pn.network, encName + " -- Side View (South to North)", uL, 52, projSideSN);
    addFooter(doc, pg);

    // Piping BOM page
    pg = addPipingBOMPage(doc, pn.network, encName, uL, pg, logoBase64);
  }
  return pg;
}
